export default __webpack_public_path__ + "static/tudor-137e3a970d8952f76f06668ba784bcff.jpg";